module.exports = __webpack_public_path__ + "assets/media/moreMenu-youtube.3041c041.svg";